import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRight = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.2441 4.41077C10.5695 4.08533 11.0971 4.08533 11.4226 4.41077L16.4226 9.41077C16.748 9.73621 16.748 10.2638 16.4226 10.5893L11.4226 15.5893C11.0971 15.9147 10.5695 15.9147 10.2441 15.5893C9.91863 15.2638 9.91863 14.7362 10.2441 14.4108L13.8215 10.8333H4.16665C3.70641 10.8333 3.33331 10.4603 3.33331 10C3.33331 9.53979 3.70641 9.16669 4.16665 9.16669H13.8215L10.2441 5.58929C9.91863 5.26385 9.91863 4.73621 10.2441 4.41077Z",
		fill: "currentColor"
	})
});
export default SvgRight;
